import React, { useState } from "react";
import styled from "styled-components";

interface ButtonTabItem {
    label: string;
    onClick: () => void;
    isSelected: boolean;
}

interface ButtonTabsProps {
    items: ButtonTabItem[];
}

export const ButtonTabs: React.FC<ButtonTabsProps> = ({
    items,
}) => {
    return (
        <TabsContainer>
            {items.map((item, index) => (
                <TabButton
                    key={item.label}
                    active={item.isSelected}
                    onClick={() => {
                        item.onClick();
                    }}
                >
                    {item.label}
                </TabButton>
            ))}
        </TabsContainer>
    );
};

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.application.border};
  overflow-x: auto;
  margin-top:10px;
`;


const TabButton = styled.button<{
    active: boolean;
}>`
  padding: 10px 20px;
  font-weight: 500;
  font-size: 1.2rem;
  border: none;
  border-bottom: ${(props) => (props.active ? `2px solid ${props.theme.application.scheme.primary}` : "2px solid transparent")};
  color: ${(props) => (props.active ? props.theme.application.scheme.primary : props.theme.application.text)};
  background: transparent;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: ${(props) => props.theme.application.scheme.primary};
  }
`;
